// removed by extract-text-webpack-plugin
module.exports = {"PayResultWrap":"style__PayResultWrap___23hQa","PayResult":"style__PayResult___2rEWI","PayResultIcon":"style__PayResultIcon___1xcAf","PayResultTitle":"style__PayResultTitle___2-Dtr","PayResultText":"style__PayResultText___2Kabn","PayResultButton":"style__PayResultButton___2BcMk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Payments/FailPage/style.scss
// module id = 1368
// module chunks = 0